// noinspection JSUnusedGlobalSymbols

import {Calendar} from '@fullcalendar/core'
import DayGridPlugin from '@fullcalendar/daygrid'
import InteractionPlugin from '@fullcalendar/interaction'
import FullCalendarJa from '@fullcalendar/core/locales/ja'
import Cookies from 'js-cookie'
import _ from 'lodash'
import Qs from 'qs'
import Dayjs from 'dayjs'
import Helper from '../../../client/helper.js'
import Network from '../../../client/network.js'
import Toast from '../../../client/toast.js'
import Is from '../../../client/is.js'
import {ErrorExternal} from '../../../server/error.js'

// noinspection JSFileReferences
import SweetAlert2 from 'sweetalert2/dist/sweetalert2.min.js'

export default class
{
	static _calendar

	static _staff = {}

	static _shift_pattern = {}

	static _shop_open = {}

	static _selected_staff = null

	static _shift_state = {}

	static _confirm = false

	static init(staff_id)
	{
		this._selected_staff = staff_id

		$.get('/shift/staff/', (data) =>
		{
			this._staff = data

			$.get('/shift/shift_pattern/', (data) =>
			{
				this._shift_pattern = data
				this._load()
			})
		})

		window.onbeforeunload = () =>
		{
			if(this._confirm) return ''
		}
	}

	static _load()
	{
		const action_event = (data) =>
		{
			if(data.event.extendedProps.type === 'shop_open') return
			const property = data.event.extendedProps

			const start = property.start ? property.start.split(/:/) : ['', '']
			const end = property.end ? property.end.split(/:/) : ['', '']

			let staff_option = ''
			let staff_id = null

			for(const staff of this._staff)
			{
				staff_option += `<option value="${staff.base}:${staff.name}"${staff.name === property.staff_name ? ' selected' : ''}>${staff.name}</option>`
				if(staff.name === property.staff_name) staff_id = staff.id
			}

			let pattern_option = ''

			for(const pattern of this._shift_pattern)
			{
				pattern_option += `<option value="${pattern.start}-${pattern.end}"${`${pattern.start}-${pattern.end}` === `${start[0]}:${start[1]}-${end[0]}:${end[1]}` ? ' selected' : ''}>${pattern.name}${pattern.short_name ? ` (${pattern.short_name})` : ''}</option>`
			}

			const off = Boolean(property.removed)
			const covered = $(data.el).hasClass('_covered')

			const hour_list = {
				start: '',
				end  : '',
			}

			for(let hour = 7; hour <= 23; hour++)
			{
				const hour_padded = String(hour).padStart(2, '0')

				hour_list.start += `<option${start[0] === hour_padded ? ' selected' : ''}>${hour_padded}</option>\n`
				hour_list.end += `<option${end[0] === hour_padded ? ' selected' : ''}>${hour_padded}</option>\n`
			}

			const option = {
				html             : `
<form class="_input">
	<div>
		<div style="margin-bottom: 10px">
			<div class="_shift_date">${data.event.startStr.replace(/^(\d+)-(\d+)-(\d+)$/, `$1${Helper.message('#message-year')}$2${Helper.message('#message-month')}$3${Helper.message('#message-day')}`)}</div>
			<div class="my-2">${Helper.message('#message-open_time')} : ${data.event.extendedProps.open ?? Helper.message('#message-closed')}</div>
			<select class="text-neutral-800${this._selected_staff ? ' hidden' : ''}" name="staff">
				<option value="">(${Helper.message('#message-please_select')})</option>
				${staff_option}
			</select>
		</div>

		<div class="pretty p-switch p-fill">
			<input type="checkbox" name="open" value="1"${off ? '' : ' checked'}>
			<div class="state">
				<label>${Helper.message('#message-attend')}</label>
			</div>
		</div>

		<div class="inline-block">
			<select name="start_hour">
				${hour_list.start}
		 	</select>
			:
			<select name="start_minute">
				<option${start[1] === '00' ? ' selected' : ''}>00</option>
				<option${start[1] === '30' ? ' selected' : ''}>30</option>
		 	</select>
			〜
			<select name="end_hour">
				${hour_list.end}
		 	</select>
			:
			<select name="end_minute">
				<option${end[1] === '00' ? ' selected' : ''}>00</option>
				<option${end[1] === '30' ? ' selected' : ''}>30</option>
		 	</select>
		</div>

		<div class="inline-block text-sm ml-5">
			${Helper.message('#message-attend_pattern')}
			<br>
			<select id="shift_pattern" onchange="App.Shift.set_pattern(this)">
				<option value="">---</option>
				${pattern_option}
			</select>
		</div>
	</div>

	<input type="hidden" name="shift" value="${data.event.id}">
	<input type="hidden" name="date" value="${data.event.startStr}">
	<input type="hidden" name="cover_start" value="${data.event.extendedProps.cover_start ?? ''}">
	<input type="hidden" name="cover_end" value="${data.event.extendedProps.cover_end ?? ''}">
	<input type="hidden" name="delete" value="0">
	<input type="hidden" name="action" value="edit">
</form>
`,
				showCancelButton : true,
				confirmButtonText: Helper.message('#message-ok'),
				cancelButtonText : Helper.message('#message-cancel'),
				denyButtonText   : Helper.message('#message-reset'),
				width            : '40em',
				showClass        : {
					popup: 'animate__animated animate__fadeIn animate__faster',
				},
			}

			if(covered && !off) option.showDenyButton = true

			SweetAlert2.fire(option).then((result) =>
			{
				if(!result.isConfirmed && !result.isDenied) return

				if(result.isConfirmed)
				{
					this._confirm = true
				}
				else if(result.isDenied)
				{
					$('form._input input[name="delete"]').val(1)
				}

				const state = new FormData($('form._input')[0])
				this._update_state(state, data.event)
			})
		}

		const action_date = (event) =>
		{
			if(!this._shop_open[event.dateStr]) return
			const event_person = {}

			for(const each of this._calendar.getEvents())
			{
				if(event.dateStr !== each.startStr) continue

				for(const key in each.extendedProps)
				{
					if(key === 'staff_name') event_person[each.extendedProps[key]] = each
				}
			}

			if(this._selected_staff)
			{
				const day_event = []
				for(const each of this._calendar.getEvents()) if(event.dateStr === each.startStr) day_event.push(each)

				if(day_event.length > 1)
				{
					const element = document.createElement('a')
					element.className = day_event[1].classNames.join(' ')

					return action_event({event: day_event[1], el: element})
				}
			}

			let staff_option = ''

			for(const staff of this._staff)
			{
				staff_option += `<option value="${staff.base}:${staff.name}"${this._selected_staff === staff.base ? ' selected' : ''}>${staff.name}</option>`
			}

			let pattern_option = ''

			for(const pattern of this._shift_pattern)
			{
				pattern_option += `<option value="${pattern.start}-${pattern.end}">${pattern.name}${pattern.short_name ? ` (${pattern.short_name})` : ''}</option>`
			}

			let hour_list = ''
			for(let hour = 7; hour <= 23; hour++) hour_list += `<option>${String(hour).padStart(2, '0')}</option>\n`

			SweetAlert2.fire({
				html             : `
<form class="_input">
	<div class="mb-2">
		<div class="_shift_date">${event.dateStr.replace(/^(\d+)-(\d+)-(\d+)$/, `$1${Helper.message('#message-year')}$2${Helper.message('#message-month')}$3${Helper.message('#message-day')}`)}</div>
		<div class="my-2">${Helper.message('#message-open_time')} : ${this._shop_open[event.dateStr] ?? Helper.message('#message-closed')}</div>
		<select class="text-neutral-800" name="staff">
			<option value="">(${Helper.message('#message-please_select')})</option>
			${staff_option}
		</select>
	</div>

	<div class="pretty p-switch p-fill">
		<input type="checkbox" name="open" value="1" checked>
		<div class="state">
			<label>${Helper.message('#message-attend')}</label>
		</div>
	</div>

	<div class="inline-block">
		<select name="start_hour">
			${hour_list}
	 	</select>
		:
		<select name="start_minute">
			<option>00</option>
			<option>30</option>
		</select>
		〜
		<select name="end_hour">
			${hour_list}
	 	</select>
		:
		<select name="end_minute">
			<option>00</option>
			<option>30</option>
		</select>
	</div>

	<div class="inline-block text-sm ml-5">
		${Helper.message('#message-attend_pattern')}
		<br>
		<select id="shift_pattern" onchange="App.Shift.set_pattern(this)">
			<option value="">---</option>
			${pattern_option}
		</select>
	</div>

	<input type="hidden" name="date" value="${event.dateStr}">
	<input type="hidden" name="action" value="add">
</form>
`,
				showCancelButton : true,
				confirmButtonText: Helper.message('#message-ok'),
				cancelButtonText : Helper.message('#message-cancel'),
				width            : '40em',
				showClass        : {
					popup: 'animate__animated animate__fadeIn animate__faster',
				},
			}).then((result) =>
			{
				if(!result.isConfirmed) return
				this._confirm = true

				const state = new FormData($('form._input')[0])
				const open = $('form._input input[name="open"]')[0].checked

				try
				{
					for(const data of state)
					{
						const [key, value] = data

						switch(key)
						{
							case 'staff' :
								if(value === '') throw new ErrorExternal(Helper.message('#message-staff_not_selected'))

								const [, name] = value.split(/:/, 2)
								event_person[name]?.remove()
							break

							case 'start_hour' :
							case 'end_hour' :
								if(open && (!Is.int(value) || value < 0 || value > 23)) throw new ErrorExternal(Helper.message('#message-time_invalid'))
							break

							case 'start_minute' :
							case 'end_minute' :
								if(open && (!Is.int(value) || value < 0 || value > 59)) throw new ErrorExternal(Helper.message('#message-time_invalid'))
							break
						}
					}
				}
				catch(exception)
				{
					Toast.warning(exception.message)
					return
				}

				this._update_state(state, null, event.dateStr)
			})
		}

		const language = Helper.language() === 'ja' ? FullCalendarJa : undefined

		this._calendar = new Calendar($('#calendar')[0], {
			plugins             : [DayGridPlugin, InteractionPlugin],
			initialView         : 'dayGridMonth',
			locale              : language,
			height              : 'auto',
			showNonCurrentDates : false,
			firstDay            : 1,
			headerToolbar       : {
				left  : '',
				center: '',
				right : '',
			},
			eventContent        : function(info)
			{
				return {html: info.event.title}
			},
			eventSources        : [{
				url    : '/shift/list',
				success: (list) =>
				{
					for(const event of list)
					{
						switch(event.extendedProps.type)
						{
							case 'shop_open' :
								this._shop_open[event.start] = event.extendedProps.open
							break
						}
					}

					setTimeout(() =>
					{
						for(const event of this._calendar.getEvents())
						{
							if(event.extendedProps.type === 'shop_open') continue

							const start = event.extendedProps.start?.split(':')
							const end = event.extendedProps.end?.split(':')

							let staff_id = null
							for(const staff of this._staff) if(staff.name === event.extendedProps.staff_name) staff_id = staff.base

							this._shift_state[event._def.defId] = {
								action      : 'edit',
								cover_end   : event.extendedProps.cover_end,
								cover_start : event.extendedProps.cover_start,
								date        : Dayjs(event.start).format('YYYY-MM-DD'),
								delete      : '0',
								end_hour    : event.extendedProps.removed ? null : end[0],
								end_minute  : event.extendedProps.removed ? null : end[1],
								open        : event.extendedProps.removed ? '0' : '1',
								shift       : event.id,
								staff       : `${staff_id}:${event.extendedProps.staff_name}`,
								start_hour  : event.extendedProps.removed ? null : start[0],
								start_minute: event.extendedProps.removed ? null : start[1],
							}
						}
					}, 100)
				},
			}],
			editable            : false,
			eventBackgroundColor: '#0000',
			eventBorderColor    : '#0000',
			eventTextColor      : '#333',
			dateClick           : action_date,
			eventClick          : action_event,
			datesSet            : (event) =>
			{
				const year = event.start.getFullYear()
				const month = event.start.getMonth() + 1

				$('#shift_setting form input[name="year"]').val(year)
				$('#shift_setting form input[name="month"]').val(month)

				$('#shift_setting_month').text(`${year}${Helper.message('#message-year')}${month}${Helper.message('#message-month')}`)

				const url = `/shift/?year=${year}&month=${month}`
				window.history.pushState(null, '', url)
			},
		})

		const month = $('#calendar').data('month')
		if(month) this._calendar.gotoDate(new Date(month))

		this._calendar.render()
	}

	static change_day(weekday, checked)
	{
		for(const name of ['start_hour', 'start_minute', 'end_hour', 'end_minute'])
		{
			if(checked) $(`#row_${weekday}`).removeClass('bg-neutral-200')
			else $(`#row_${weekday}`).addClass('bg-neutral-200')
		}
	}

	static toggle_off(checked)
	{
		if(checked) Cookies.set('show_off', '1', {expires: 365, path: '/'})
		else Cookies.remove('show_off')

		location.reload()
	}

	static save_shift()
	{
		Helper.confirm(Helper.message('#message-save_confirm'), () =>
		{
			const data = new FormData()
			data.set('__action', 'shift_save')

			for(const id in this._shift_state)
			{
				data.append(`${this._shift_state[id].action}[]`, JSON.stringify(this._shift_state[id]))
			}

			this._confirm = false
			Network.post('/shift/', data, undefined, true)
		})
	}

	static _update_state(state, event = null, date = null)
	{
		const data = {}
		let staff_name = ''

		for(const pair of state.entries())
		{
			switch(pair[0])
			{
				case 'staff' :
					pair[1] = pair[1].replace(/:(.+)/, '')
					staff_name = RegExp.$1
				break

				case 'staff_name' :
					staff_name = pair[1]
				break
			}

			data[pair[0]] = pair[1]
		}

		const start = data.delete === '1' ? data.cover_start?.replace(/^(\d+:\d+):00$/, '$1') : `${data.start_hour?.padStart(2, '0')}:${data.start_minute?.padStart(2, '0')}`
		const end = data.delete === '1' ? data.cover_end?.replace(/^(\d+:\d+):00$/, '$1') : `${data.end_hour?.padStart(2, '0')}:${data.end_minute?.padStart(2, '0')}`

		if(event === null)
		{
			event = this._calendar.addEvent({
				start : date,
				allDay: true,
			})

			event.setExtendedProp('open', this._shop_open[event.startStr])
		}

		const name = this._selected_staff ? '' : ` ${staff_name}`

		event.setProp('title', data.open || data.delete === '1' ? `${start} 〜 ${end}${name}` : `休み${name}`)
		event.setProp('classNames', !data.open ? ['_removed', '_covered'] : ['_covered'])

		event.setExtendedProp('start', start)
		event.setExtendedProp('end', end)

		event.setExtendedProp('cover_start', data.cover_start)
		event.setExtendedProp('cover_end', data.cover_end)

		event.setExtendedProp('staff_name', staff_name)
		event.setExtendedProp('removed', data.open !== '1')

		if(data.delete === '1' && !data.cover_start) event.remove()

		this._shift_state[event._def.defId] = {}
		for(const pair of state.entries()) this._shift_state[event._def.defId][pair[0]] = pair[1]

		return event
	}

	static add_day()
	{
		const select = $('#day_template').clone(true)
		select.attr('id', null).removeClass('hidden').removeClass('__no-select')

		$('#day_list').append(select)

		select.select2({
			width                  : 'auto',
			minimumResultsForSearch: -1,
		})
	}

	static bulk_edit(form)
	{
		Helper.confirm(Helper.message('#message-bulk_confirm'), () =>
		{
			try
			{
				const input = new FormData(form)

				if(input.get('off') !== '1') input.set('open', '1')
				else input.delete('open')

				const staff_name = this._selected_staff ? form['staff_name'].value : form['staff'].options[form['staff'].selectedIndex].text
				const data = Qs.parse(new URLSearchParams(input).toString(), {allowDots: true})

				let list = []

				switch(data.type)
				{
					case 'each' :
						list = data.day
					break

					case 'period' :
						list = _.range(Number(data.day_start), Number(data.day_end) + 1)
					break

					case 'weekday' :
						const max = Dayjs(`${data.year}-${data.month}-01`).endOf('month').date()
						const week = data.weekday.map(number => Number(number))

						for(const day of _.range(1, max + 1))
						{
							const date = Dayjs(`${data.year}-${data.month}-${day}`)
							if(week.includes(date.day())) list.push(day)
						}
					break

					default :
						throw new ErrorExternal(Helper.message('#message-select_type'))
					break
				}

				for(const day of list)
				{
					if(!Is.int(day)) continue

					const current = this._calendar.getDate()
					const date = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`

					const day_events = this._calendar.getEvents().filter((event) => event.start.toDateString() === new Date(date).toDateString())

					input.set('date', date)
					input.set('open', data.off !== '1' ? '1' : '')

					let edited = false

					for(const event of day_events)
					{
						if(event.extendedProps.staff_name !== staff_name) continue
						input.set('action', 'edit')

						switch(input.get('state'))
						{
							case 'reset' :
								input.set('cover_start', event.extendedProps.cover_start)
								input.set('cover_end', event.extendedProps.cover_end)
								input.set('shift', event.extendedProps.shift)
								input.set('delete', '1')
							break

							case 'absent' :
								input.set('cover_start', event.extendedProps.cover_start)
								input.set('cover_end', event.extendedProps.cover_end)
								input.set('shift', event.extendedProps.shift)
								input.set('open', '')
								input.set('delete', '0')
							break
						}

						this._update_state(input, event)
						edited = true
					}

					if(!edited && !['reset', 'absent'].includes(input.get('state')))
					{
						input.set('action', 'add')
						this._update_state(input, null, new Date(date))
					}
				}

				App._common.modal_close('shift_setting')
			}
			catch(exception)
			{
				Toast.warning(exception.message)
			}
		})
	}

	static set_pattern(select)
	{
		if(select.value === '') return
		const [, start_hour, start_minute, end_hour, end_minute] = /^(\d+):(\d+)-(\d+):(\d+)$/.exec(select.value)

		select.form.querySelector(`select[name="start_hour"]`).value = start_hour
		select.form.querySelector(`select[name="start_minute"]`).value = start_minute

		select.form.querySelector(`select[name="end_hour"]`).value = end_hour
		select.form.querySelector(`select[name="end_minute"]`).value = end_minute

		select.form.querySelector(`input[name="open"]`).checked = true
	}

	static sync(button, year, month, name)
	{
		if(this._confirm)
		{
			Toast.warning(Helper.message('#message-save_before_sync'))
			return
		}

		Helper.confirm(Helper.message('#message-sync_portal_confirm', [name, year, month]), () =>
		{
			const loader = $(button).find('._loader')
			loader.addClass('css-loader')

			const data = new FormData()
			data.set('__action', 'shift_upload')

			data.set('year', year)
			data.set('month', month)

			Network.post(
				location.pathname,
				data,
				() => loader.removeClass('css-loader'),
				false,
			)
		})
	}
}
